$(function() {
	if (!$body.hasClass('page-gallery'))
		return;

	$body = $('body');

	var initGallery = function() {
		// Fix issue with videos loading in at wrong size initially.
		$('iframe').each(function() {
			$(this).load(function() {
				resizeElement(this);
			});
		});

		var slider = $('.gallery_slider');
		var modal = $('.gallery_modal');
		var activeCategory = 'resort';
		var galleryThumbs = $('.gallery_item');
		var galleryLinks = $('.gallery_link');
		var filteredGalleryThumbs = galleryThumbs;
		var categories = $('#gallery_categories a');
		var clicked = null;
		var mobile_size = 480;

		$('#filter_mobile_button').click(function(){
			$('#gallery_categories nav').toggleClass('open');
		});

		var updateUrl = function(url, image, category) {
			if (Number.isInteger(parseInt(image))) {
				url += '?image=' + image;
			}

			if (category && category != '#')
				url += category;

			if (url != window.location.href)
				window.history.pushState('', '', url);
		}
		var filterCategory = function(element) {
			galleryThumbs.removeClass('appear');
			if (element) {
				element = $(element);
				activeCategory = element.attr('href').slice(1);
			}

			galleryThumbs.hide().removeClass('first_item').removeClass('second_item');
			filteredGalleryThumbs = galleryThumbs.filter('[cat=' + activeCategory + ']');
			filteredGalleryThumbs.show().eq(0).addClass('first_item');
			filteredGalleryThumbs.show().eq(1).addClass('second_item');

			thumbsToLoad = filteredGalleryThumbs.find('[load-on-show]:not(.loaded)');
			thumbsToLoad.each(function() {
				var image = $(this);
				window.lazyLoader.lazyLoad(image, image.attr('load-on-show'));
				image.on('lazy-loaded', function() {
					setTimeout(function() {
						image.addClass('delayed_loaded');
					}, 1000);
				});
			})

			setTimeout(function() {
				filteredGalleryThumbs.addClass('appear');
			}, 50);

			updateUrl(document.location.origin + document.location.pathname, currentUrl.query(true).image, '#' + activeCategory);
		}

		categories.click(function() {
			categories.removeClass('active_category');
			$(this).addClass('active_category');
			filterCategory(this);
		});


		var stopVideo = function (element) {
			var iframe = element.find('.slick-current iframe');
			if (iframe.length) {
				var func = 'stopVideo';
				iframe[0].contentWindow.postMessage('{"event":"command","func":"' + func + '","args":""}','*');
			}
		};

		var stopStream = function (element) {
			element.find('img.stream').attr('src', '');
		}

		// Activate the proper category and imageon page load
		var currentUrl = URI(document.location);
		if (currentUrl.hash()) {
			var currentlySelected = categories.filter('[href="' + currentUrl.hash() + '"]');

			if (currentlySelected.length) {
				currentlySelected.trigger('click')
			} else {
				categories.eq(0).trigger('click');
			}
		} else {
			categories.eq(0).trigger('click');
		}

		galleryLinks.click(function(e) {
			if ($window.width() > mobile_size)
				e.preventDefault();
		});

		if ($window.width() > mobile_size) {

			var ieVersion = ie_version();
			if (ieVersion && ieVersion != 'edge') {
				$('.ie_message').addClass('is_ie');
				$('.open_gallery_item .ie_only').addClass('is_ie');
				$('.open_gallery_item .not_ie').hide();
			}

			// $('#gallery_categories').accessibleScaffold({
			// 	items: 'a',
			// 	orientation: 'horizontal',
			// 	onEnterKey: function(item) {
			// 		filterCategory(item);
			// 	}
			// });

			$(slider).on('init', function() {
				slider.find('cite').attr("tabindex", -1);
				slider.find('.slick-current cite').attr("tabindex", 0).focus();
			});

			initializeSlick(slider, {
				accessibility: true,
				dots: false,
				infinite: true,
				speed: 700,
				slidesToShow: 1,
				arrows: true,
				fade: true,
				nextArrow: '<button class="slider_arrow next_arrow">Next</button>',
				prevArrow: '<button class="slider_arrow prev_arrow">Previous</button>',
				// focusOnSelect: true,
			});

			var openSlider = function(index) {
				clicked = index;
				slider.slick('slickUnfilter');
				if (activeCategory != 'all')
					slider.slick('slickFilter', '[cat=' + activeCategory + ']');
				slider.slick('slickGoTo', index);
				modal.addClass('open');
				slider.focus();

				slider.find('.cite').attr("tabindex", 0);
				slider.find('.slick-current cite').focus();

				slider.find('.slick-current').find('.alert_bar').addClass("visible");

				var img = slider.find('.slick-current').find('img.gallery_image');
				if (!img.attr('src'))
					window.lazyLoader.lazyLoad(img, img.attr('load-on-show'));

				if (slider.find('video').length)
					slider.find('video').get(0).play();

				manageStreamSrcAttribute(null, index);

				$body.addClass('modal_open');

				$body.find("*[tabindex='0'], a, button, input, .site_container > .alert_bar").not('.gallery_modal, .gallery_modal *').attr("tabindex-changed", true).attr("tabindex", -1);

				// Update url so user can link to this specific image.
				updateUrl(document.location.origin + document.location.pathname, index, document.location.hash);
			}

			// var thumbsComponent = $('section.gallery').accessibleScaffold({
			// 	items: 'div.gallery_item',
			// 	orientation: 'horizontal',
			// 	ariaRole: 'Grid',
			// 	onEnterKey: function(elem, i) {
			// 		openSlider(i);
			// 	}
			// });

			//On slide change, check if video and stop playing
			$(slider).on('beforeChange', function(event, slick, currentSlide, nextSlide){
				var slideCat = $('.slick-current').attr('cat');
				if(slideCat == "video"){
			  		stopVideo(modal);
			  	};

				slider.find('.slick-current').find('.alert_bar').removeClass("visible");
				slider.find('.open_gallery_item').eq(nextSlide).find('.alert_bar').addClass("visible");

				var img = slider.find('.open_gallery_item').eq(nextSlide).find('img.gallery_image');

				if (!img.attr('src'))
					window.lazyLoader.lazyLoad(img, img.attr('load-on-show'));

				manageStreamSrcAttribute(currentSlide, nextSlide);

			});

			$(slider).on('afterChange', function(event, slick, currentSlide, nextSlide){
				slider.find('.cite').attr("tabindex", 0);
				slider.find('.slick-current cite').focus();
			});

			var manageStreamSrcAttribute = function(stop, start) {
				if (activeCategory == 'live-cam') {
					var streamImages = $('.open_gallery_item[cat="live-cam"]');
					var nextStreamImage = streamImages.eq(start).find('img.stream');

					if (nextStreamImage.length)
						nextStreamImage.attr('src', nextStreamImage.attr('_src'));

					if (stop !== null) {
						var prevStreamImage = streamImages.eq(stop).find('img.stream');
						prevStreamImage.attr('src', '');
					}
				}
			}

			var closeModal = function() {
				modal.removeClass('open');
				$body.removeClass('modal_open');
				stopVideo(modal);
				stopStream(modal);
				updateUrl(document.location.origin + document.location.pathname, null, document.location.hash);
				$body.find("*[tabindex-changed='true'], a, button, input").not('.gallery_modal, .gallery_modal *').attr("tabindex", 0);
			}

			modal.click(function(e) {
				if ($(e.target).hasClass('gallery_modal') || $(e.target).hasClass('close')) {
					closeModal();
					return false;
				}
			});

			$('.close.gallery_close').on("click keypress", function(e) {
				closeModal();
			});

			$('.gallery_image').on('lazy-loaded', function(e) {
				$(e.target).parent().parent().addClass('loaded');
			});

			$(window).keydown(function(e) {
				if (e.key == 'Escape') {
					closeModal();
					thumbsComponent.api.activate(clicked);
					clicked = null;
				}
			});

			galleryThumbs.on("click keypress", function(e) {
				var index = filteredGalleryThumbs.index(e.currentTarget);
				openSlider(index);
				return false;
			})

			setTimeout(function() {
				var initialImage = currentUrl.query(true).image;

				if (initialImage) {
					galleryThumbs.filter(':visible').eq(initialImage).trigger('click');
				}
			}, 100);
		} else {
			$('.gallery_item.webcam').on("click keypress", function() {
				var index = $(this).index();
				var src = $('.open_gallery_item').eq(index).find('.stream_wrapper iframe').attr('src');

				window.open(
					src,
					'_blank'
				);
				return false;
			})
		}


		setTimeout(function() {
			if ($window.width() < mobile_size) {
				var currentImage = currentUrl.query(true).image
				console.log('doneLoading', currentImage, galleryThumbs.filter(':visible').eq(currentImage), galleryThumbs.eq(currentImage).offset())
				if (Number.isInteger(parseInt(currentImage))) {
					$(window).scrollTop(galleryThumbs.filter(':visible').eq(currentImage).offset().top - 105);
				}
			}
		}, 2000);

		$(window).load(function() {
			imagesToLoad = $('.gallery [load-on-show]:not(.loaded)');

			var continueLoading = function(i) {
				var toLoad = imagesToLoad.eq(i);

				if (!toLoad.length) {
					return;
				}

				if (toLoad.hasClass('loaded'))
					return continueLoading(i+1);

				window.lazyLoader.lazyLoad(toLoad, toLoad.attr('load-on-show'));
				toLoad.on('lazy-loaded', function() {
					toLoad.addClass('delayed_loaded');
					continueLoading(i+1);
				});
			}

			continueLoading(0);
		});
	}

	var waitForReady = setInterval(function() {
		if ($('body').hasClass('ready')) {
			initGallery();
			clearInterval(waitForReady);
		}
	}, 50);
});